import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, shareReplay, switchMap } from "rxjs/operators";
import { ProfileService } from "../profile/profile.service";

@Injectable({ providedIn: "root" })
export class FeaturesService {
    private httpClient = inject(HttpClient);
    private profileService = inject(ProfileService);

    private enabledFeatures$ = this.profileService.getOrganizationId$().pipe(
        switchMap((organizationId) => this.httpClient.get<Array<string>>(`/api/organizations/${organizationId}/features`)),
        shareReplay(1)
    );

    public getEnabledFeatures$(): Observable<Array<string>> {
        return this.enabledFeatures$;
    }

    public isEnabled$(feature: string): Observable<boolean> {
        return this.enabledFeatures$.pipe(map((features) => features?.includes(feature) ?? false));
    }
}
